import type { SubmissionSummary } from '@coffman-tm/shared';

/**
 * Initial value for the block card's submission picker. The server's
 * sole-rollup-wins save rule means a save always joins whatever submission
 * already owns the block's (PCO, week) — regardless of what the picker shows
 * — so defaulting the picker to anything else is a UI claim the save won't
 * honor. Live case (2026-07-31): a 6/27 block defaulted to 002.12 while its
 * week's rollup already sat in open 002.11.
 *
 * Preselect the week owner ONLY while it is itself `open` — a week owned by a
 * closed/approved submission gets no special preselect (the sent-week /
 * imported-history warnings already own that case) and falls back to the
 * PCO's default target, same as an unowned week.
 */
export function pickInitialSubmissionChoice(
  weekOwner: SubmissionSummary | null,
  defaultSubmission: SubmissionSummary | null,
): string {
  if (weekOwner && weekOwner.status === 'open') return weekOwner.id;
  return defaultSubmission?.id ?? '';
}
